<script lang="ts">
  import { Col, Card } from "sveltestrap";
  export let discrpition: string;
  export let headerprops: string;
</script>

<Col sm="12">
  <Card class="alert alert-primary" role="alert">
    <h5 class={headerprops}>Tip!</h5>
    <p>{discrpition}</p>
  </Card>
</Col>
